import { render, staticRenderFns } from "./registNumber.vue?vue&type=template&id=56a42e06&scoped=true"
import script from "./registNumber.vue?vue&type=script&lang=js"
export * from "./registNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a42e06",
  null
  
)

export default component.exports